import { QUERY_KEYS } from '@src/query';
import { Call } from '@src/services/api';
import { useQuery } from '@tanstack/react-query';
import { ParamsGetMetabaseEmbed, ResGetMetabaseEmbed } from 'common/dist/types/apiTypes';

const METABASE_TOKEN_REFRESH_LEAD_MS = 60 * 1000;
const METABASE_TOKEN_REFRESH_MIN_DELAY_MS = 1000;

/**
 * Return the delay that renews a Guest token before its JWT expiry.
 * `expiresAt` is expressed in Unix seconds by the backend.
 */
export function getMetabaseTokenRefreshDelay(
  expiresAt: number | undefined,
  now = Date.now(),
): number | false {
  if (!expiresAt) {
    return false;
  }

  return Math.max(
    METABASE_TOKEN_REFRESH_MIN_DELAY_MS,
    expiresAt * 1000 - now - METABASE_TOKEN_REFRESH_LEAD_MS,
  );
}

export const useQueryMetabaseEmbed = (
  params: ParamsGetMetabaseEmbed,
  enabled: boolean,
) =>
  useQuery<ResGetMetabaseEmbed>({
    queryKey: QUERY_KEYS.metabaseEmbed(params),
    queryFn: () => Call.get<ResGetMetabaseEmbed, ParamsGetMetabaseEmbed>(
      '/api/analytics/metabase-embed',
      params,
    ),
    enabled,
    staleTime: 1000 * 60 * 5,
    refetchInterval: (query) => getMetabaseTokenRefreshDelay(query.state.data?.expiresAt),
    refetchIntervalInBackground: true,
  });
